import { create } from 'zustand';

/**
 * Estado global do modal "+Novo Deal" (E6 PR2). O botão fica na topbar e o modal é montado uma vez
 * no shell (AppLayout) — store global (zustand) desacopla o gatilho do render, no mesmo padrão do
 * dealDrawerStore.
 */
interface NewDealState {
  open: boolean;
  openNew: () => void;
  closeNew: () => void;
}

export const useNewDeal = create<NewDealState>()((set) => ({
  open: false,
  openNew: () => set({ open: true }),
  closeNew: () => set({ open: false }),
}));
